import { Component } from "@angular/core";

@Component({
    selector: 'app-root',
    templateUrl: '../view/app.html'
})
export class AppComponent {
    constructor() {}
}